import RecommendationStamp from './RecommendationStamp';

export default RecommendationStamp;
